import { combineReducers } from 'redux';
import { singleValueReducer } from 'store/reducerUtils';
import { setOpenCompensationChange } from 'modules/subassignmentManagement/components/CompensationChange/store/actions';

const isOpenBulkCreationModal = singleValueReducer(setOpenCompensationChange.action, false);

export const compensationChange = combineReducers({
    isOpenBulkCreationModal,
});
